//////////////////////////////////////////////////////////////
//     							                                        //
//  Program: PropertyAccommodationAgreementService.js       //
//  Application: PropertyAccommodationAgreementService      //
//  Option: Used to manage Property Accommodation           //
//          Agreement overrides                             //
//  Date: 2026-07-10                                        //
//                                                          //
//////////////////////////////////////////////////////////////

import ApiService from "./ApiService";

class PropertyAccommodationAgreementService {
  getPropertyAgreement(propertySlug) {
    let endPoint = "get-property-accommodation-agreement/" + propertySlug;
    let addditionalHeaderData = {};
    let postData = {};

    let inputData = {
      endPoint: endPoint,
      addditionalHeaderData: addditionalHeaderData,
      postData: postData,
    };
    let response = ApiService.getCall(inputData);
    return response;
  }

  addOrUpdateAgreement(data) {
    // Delete data which we don't want to send
    delete data.errors;
    delete data.input;

    let endPoint = "add-update-property-accommodation-agreement";
    let addditionalHeaderData = {};
    let postData = data;

    let inputData = {
      endPoint: endPoint,
      addditionalHeaderData: addditionalHeaderData,
      postData: postData,
    };
    let response = ApiService.postCall(inputData);
    return response;
  }
}

export default new PropertyAccommodationAgreementService();
